import { MutationTree } from 'vuex'
import { RealworksStatusRuleState } from '@/store/realworksStatusRules/index'
import { PageResult } from '@/api/types'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'

export const mutations: MutationTree<RealworksStatusRuleState> = {
    fetchData(state: RealworksStatusRuleState): void {
        state.loading = true
        state.totalItems = null
        state.error = null
    },

    fetchDataSuccess(state: RealworksStatusRuleState, result: PageResult<RealworksStatusRule>): void {
        state.loading = false
        state.error = null
        state.realworksStatusRules = result.collection
        state.totalItems = result.totalItems
        state.totalPages = result.totalPages
    },

    fetchDataFailure(state: RealworksStatusRuleState, error: string): void {
        state.loading = false
        state.error = error
    },

    setPage(state: RealworksStatusRuleState, payload: {page: number }): void {
        state.page = payload.page
    },

    applyOrder(state: RealworksStatusRuleState, payload: { field: string, direction: string}): void {
        state.orderField = payload.field
        state.orderDirection = payload.direction
    },

    applyCompanyFilter(state: RealworksStatusRuleState, payload: {query: string }): void {
        state.companyFilter = payload.query
    },
}
